import {inject} from '@angular/core';
import {CanActivateFn, Router,} from '@angular/router';
import {UserRole, UserRoleStore} from '../states/user-role-stare/client-role-state.store';

export const IsAdminGuard: CanActivateFn = () => {
  const userState = inject(UserRoleStore);
  const router = inject(Router);
  const user: UserRole | null = userState.user();

  if (!user) {
    return false;
  }
  const isAdmin = user.group === 'ADMIN';
  if (!isAdmin) {
    alert("No tienes acceso a la ruta")
    router.navigate(['/campaña']);
    return false;
  }

  return true;
};
